import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo, setTitle } from '@/libs/util'

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login';
const REG_PAGE_NAME = 'reg';
const WEB_HOME_PAGE ='webHome'


const turnTo = (to,from, access, next) => {
  // console.log(to)
  if (canTurnTo(to.name, access, routes)) next();// 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}


router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  const token = getToken();
  if(!token &&  to.name === LOGIN_PAGE_NAME){
    //未登录且跳转登录页 跳转
    next()
  }else if(!token &&  to.name === REG_PAGE_NAME){
    //未登录且跳转注册 跳转
    next()
  }else if(!token && to.matched.some( m => m.meta.auth)){
    //未登录且跳转展示页面 跳转
    next()
  } else if(token && to.name === LOGIN_PAGE_NAME){
    //如果已登录且跳转登录页 重定向到工作台
    next({
      name: 'workbench'
    })
  }else if(token && to.matched.some( m => m.meta.auth)){
    //登录 且不需要校验的路由 （登录 首页 注册等）
    next()
  }else{
    // next()
    if (store.state.user.hasAccessFlag) {
      turnTo(to,from, store.state.user.access, next)
    } else {
      store.dispatch('getuserpermission').then(user => {
        let newAccess = user.map(item=>{
          return item.id
        })
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        turnTo(to, from,newAccess, next)
      }).catch(() => {
        setToken('')
        next({
          name: 'login'
        })
      })
    }
    // 再次通过接口需要判断 token是否有效
  }
});

router.afterEach(to => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0)
  store.state.toPathName  = to.meta.homeRouter;  //723 左侧路由  那些隐藏的或者主页面的路由 激活父级的路由
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js